export default "__VITE_ASSET__d1b97e62__"